import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import classes from "./AADTForm.module.css";
import * as Yup from "yup";
import { yearRegex } from "../../../../globals.js";
import Aux from "../../../../hoc/Auxilary";

class AADTForm extends Component {
  render() {
    console.log(this.props.values);
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        console.log("errors", errors);

        if (Object.keys(errors).length !== 0) {
          this.props.setFieldTouched("daily_traffic", true);
          this.props.setFieldTouched("notes", true);
          this.props.setFieldTouched("year", true);
          console.log("cannot submit! Validation failed", errors);
        } else {
          values.project_id = this.props.projectID;
          func(values);
          this.props.resetForm();
          this.props.toggleSmallModalHandler();
        }
      });
    };

    return (
      <Form className={classes.AADTForm}>
        <label>
          <strong>Year</strong>
          <Field name={"year"} value={this.props.values.year || ""} />
        </label>
        {this.props.errors.year && this.props.touched.year && (
          <span className={classes.Error}>{this.props.errors.year}</span>
        )}

        <label>
          <strong>Daily Traffic</strong>

          <Field
            name={"daily_traffic"}
            value={this.props.values.daily_traffic || ""}
          />
        </label>
        {this.props.errors.daily_traffic &&
          this.props.touched.daily_traffic && (
            <span className={classes.Error}>
              {this.props.errors.daily_traffic}
            </span>
          )}

        <label>
          Notes
          <Field name={"notes"} value={this.props.values.notes || ""} />
        </label>

        {!this.props.currentAADT ? (
          <button
            type="button"
            onClick={() => {
              validAndHandle(this.props.add, this.props.values);
            }}
          >
            Submit
          </button>
        ) : (
          <Aux>
            <button
              type="button"
              onClick={() => {
                validAndHandle(this.props.update, this.props.values);
              }}
            >
              Update
            </button>
          </Aux>
        )}
        <button type="button" onClick={this.props.toggleSmallModalHandler}>
          Cancel
        </button>
        <button type="button" onClick={this.props.handleReset}>
          Reset
        </button>
      </Form>
    );
  }
}

var aadtSchema = Yup.object().shape({
  daily_traffic: Yup.string().required(),
  year: Yup.string().matches(yearRegex, "Invalid year").typeError("Must be a year type")
    .required()
});

export default withFormik({
  validationSchema: aadtSchema,

  mapPropsToValues({ currentAADT }) {
    return {
      ...currentAADT
    };
  }
})(AADTForm);
